export default __webpack_public_path__ + "static/media/satori.33bbef06.jpg";